<div class="isg-full-page-header">

  <div class="isg-page-header">
    <span>Licenses</span>
  </div>

  <div class="isg-page-body">

    <div class="isg-lic-gridpane" isgSizer #gridPane="isgSizer">

      <kendo-grid [data]="view | async"
                  [loading]="service.loading"
                  [pageSize]="state.take ?? 15"
                  [skip]="state.skip ?? 0"
                  [sort]="state.sort ?? []"
                  [pageable]="{
                      pageSizes:[5, 10, 15, 20, 50, 100]
                    }"
                  [height]="gridPane.height()"
                  (edit)="onEditLicense($event)"
                  (add)="onAddLicense()"
                  (dataStateChange)="onStateChange($event)">

        <ng-template kendoGridToolbarTemplate>
          <button kendoGridAddCommand type="button" *ngIf="showAdd">
            <span class="fas fa-plus" title="Add New License"></span>
          </button>

          <kendo-label [for]="companySelect" text="Companies"></kendo-label>
          <kendo-combobox #companySelect
                          class="isg-cb-select"
                          style="margin-left:12px;width:250px"
                          valueField="id"
                          textField="name"
                          [(ngModel)]="selectedCompanyItem"
                          [data]="companies"
                          [suggest]="true">
          </kendo-combobox>

          <isg-click-filter style="width:13rem"
                            [(ngModel)]="licActive"
                            [textNotSpecified]="'Show All Licenses'"
                            [textTrue]="'Show Active Licenses'"
                            [textFalse]="'Show Inactive Licenses'"></isg-click-filter>

          <button kendoButton type="button" (click)="onSearchClick()">
            <span class="fas fa-magnifying-glass" title="Search"></span>
          </button>

          <button kendoButton type="button" class="isg-button-icon" (click)="onTemplatesClick()">
            <span class="fas fa-gears" title="Role Templates"></span>
          </button>

          <button kendoButton
                  type="button"
                  class="isg-button-label"
                  [disabled]="loadingPanelVisible()"
                  title="Download every user in every company as Excel"
                  (click)="onDownloadAllUsers($event)">
            <span class="fas fa-file-excel"></span>
            All Users
          </button>

        </ng-template>

        <kendo-grid-column [hidden]="true" field="id" title="Id"></kendo-grid-column>

        <kendo-grid-column [hidden]="true" field="extLicenseId" title="extLicenseId"></kendo-grid-column>

        <kendo-grid-column field="isActive" title="Active" editor="boolean" [width]="80" class="isg-kgrid-cell-center">
          <ng-template kendoGridCellTemplate let-dataItem>
            <span [appNullableBooleanClass]="dataItem.isActive"></span>
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column field="companyName" title="Company" [width]="150"></kendo-grid-column>

        <kendo-grid-column [hidden]="true" field="applicationId" title="applicationId"></kendo-grid-column>

        <kendo-grid-column field="name" title="Name" [width]="200"></kendo-grid-column>

        <kendo-grid-column [hidden]="true" field="sqlConnBespoke" title="sqlConnBespoke"></kendo-grid-column>

        <kendo-grid-column field="startDate" title="Start Date" editor="date" [width]="100">
          <ng-template kendoGridCellTemplate let-dataItem>
            {{dataItem.startDate | datePreference:false}}
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column field="endDate" title="End Date" editor="date" [width]="100">
          <ng-template kendoGridCellTemplate let-dataItem>
            {{dataItem.endDate | datePreference:false}}
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column field="description" title="Description" [width]="200">
          <ng-template kendoGridCellTemplate let-dataItem>
            <div class="isg-kgrid-cell-vertscroll-m">
              {{ dataItem.description }}
            </div>
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column [hidden]="true" field="enforceEndDate" title="Enforce End Date" editor="boolean" [width]="100" class="isg-kgrid-cell-center">
          <ng-template kendoGridHeaderTemplate>
            Enforce <br /> End Date
          </ng-template>
          <ng-template kendoGridCellTemplate let-dataItem>
            <span [appNullableBooleanClass]="dataItem.enforceEndDate"></span>
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column field="maxUsers" title="Max Users" editor="numeric" [width]="80">
          <ng-template kendoGridHeaderTemplate>
            Max <br /> Users
          </ng-template>
          <ng-template kendoGridCellTemplate let-dataItem>
            {{ dataItem.maxUsers | emptyNumberFormat }}
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column field="assignedUsers" title="Assigned Users" editor="numeric" format="#" [width]="80">
          <ng-template kendoGridHeaderTemplate>
            Assigned <br /> Users
          </ng-template>
          <ng-template kendoGridCellTemplate let-dataItem>
            {{ dataItem.assignedUsers | emptyNumberFormat }}
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column [hidden]="true" field="enforceUsers" editor="boolean" [width]="80" class="isg-kgrid-cell-center">
          <ng-template kendoGridHeaderTemplate>
            Enforce <br /> Users
          </ng-template>
          <ng-template kendoGridCellTemplate let-dataItem>
            <span [appNullableBooleanClass]="dataItem.enforceUsers"></span>
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column [hidden]="true" field="homePage" title="homePage"></kendo-grid-column>

        <kendo-grid-column [hidden]="true" field="osProjectId" title="osProjectId"></kendo-grid-column>
        <kendo-grid-column [hidden]="true" field="osProjectNumber" title="osProjectNumber"></kendo-grid-column>
        <kendo-grid-column [hidden]="true" field="osProjectName" title="osProjectName"></kendo-grid-column>
        <kendo-grid-column [hidden]="true" field="osContractId" title="osContractId"></kendo-grid-column>
        <kendo-grid-column [hidden]="true" field="osOpportunityId" title="osOpportunityId"></kendo-grid-column>

        <kendo-grid-column [hidden]="true" field="lastModifiedBy" title="Last Modified"></kendo-grid-column>

        <kendo-grid-column field="lastModifiedOn" title="Last Modified On" editor="date" [width]="120" media="(min-width: 1920px)">
          <ng-template kendoGridHeaderTemplate>
            Last <br /> Modified On
          </ng-template>
          <ng-template kendoGridCellTemplate let-dataItem>
            {{dataItem.lastModifiedOn | datePreference:false}}
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column field="lastModifiedByName" title="last Modified" [width]="120" media="(min-width: 1720px)">
          <ng-template kendoGridHeaderTemplate>
            Last <br /> Modified By
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-command-column title="" [width]="150">
          <ng-template kendoGridCellTemplate let-isNew="isNew" let-dataItem="dataItem">
            <button *ngIf="showEditButton"
                    kendoGridEditCommand
                    title="Edit License"
                    [primary]="true">
              <span class="fas fa-pencil"></span>
            </button>
            <button *ngIf="showReadOnlyButton && (showEditButton !== true)"
                    kendoGridEditCommand
                    title="View License"
                    [primary]="true">
              <span class="fas fa-magnifying-glass"></span>
            </button>
            <button kendoButton type="button" class="isg-button-icon" (click)="onLicenseUserManageClick(dataItem)">
              <span class="fas fa-user" title="User management"></span>
            </button>
            <button kendoButton type="button" title="Roles" (click)="onRolesClick(dataItem)">
              <span class="far fa-solid fa-gear"></span>
            </button>
            <button kendoButton type="button" class="isg-button-icon" (click)="onUserPermissionsClick(dataItem)" role="link">
              <span class="fas fa-user-shield" title="User permissions"></span>
            </button>
          </ng-template>
        </kendo-grid-command-column>

        <kendo-grid-messages [pagerItemsPerPage]="'Licenses per request'" [pagerItems]="'Licenses'"
                             [pagerOf]="'of'" [pagerPage]="'Page'">
        </kendo-grid-messages>

      </kendo-grid>

      <app-license-grid-editor [dataItem]="editDataItem"
                               [isNew]="isNew"
                               [companies]="companies"
                               [isReadOnly]="!showEditButton"
                               [showOneSysSettings]="showOneSysSettings"
                               (save)="onSaveLicense($event)"
                               (cancel)="onCancelLicense()">
      </app-license-grid-editor>

    </div>

    <isg-loader *ngIf="loadingPanelVisible()">
    </isg-loader>

  </div>

</div>
